import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";
import HeroBanner from "./components/HeroBanner";
import CategorySection from "./components/CategorySection";
import HotComics from "./components/HotComics";
import LatestUpdates from "./components/LatestUpdates";
import RecommendedSection from "./components/RecommendedSection";

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "韩漫在线",
  url: typeof window !== "undefined" ? window.location.origin : "",
  description: "韩漫在线 - 免费韩国漫画在线阅读平台，提供高清画质下拉式漫画阅读体验，覆盖爱情、奇幻、动作、悬疑等多种类型韩国漫画全集。",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://manhuaonline.com/search?q={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
  inLanguage: "zh-CN",
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <HotComics />
        <LatestUpdates />
        <RecommendedSection />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              随时随地，畅享韩漫
            </h2>
            <p className="text-sm text-foreground-600 max-w-2xl mx-auto mb-6">
              韩漫在线提供免费下拉式韩国漫画在线阅读，高清画质、流畅体验，支持PC、平板和手机多种设备。无论你在哪里，都能尽情享受韩国漫画的魅力。
            </p>
            <button className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer">
              立即开始阅读
            </button>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}